(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solid8-cro-header"]) return;
  try {
    
document.querySelectorAll(".s8-concept .menu-toggle").forEach(b=>b.addEventListener("click",()=>{const open=b.getAttribute("aria-expanded")!=="true";b.setAttribute("aria-expanded",String(open));document.getElementById("main-menu").classList.toggle("is-open",open)}));
document.querySelectorAll('[data-s8-announcement]').forEach(bar=>{
  const messages=Array.from(bar.querySelectorAll('.announcement-message'));
  let active=0;
  const timer=window.setInterval(()=>{
    if(!bar.isConnected){window.clearInterval(timer);return;}
    if(document.hidden||bar.matches(':hover'))return;
    messages[active].classList.remove('is-active');
    messages[active].setAttribute('aria-hidden','true');
    active=(active+1)%messages.length;
    messages[active].classList.add('is-active');
    messages[active].removeAttribute('aria-hidden');
  },4500);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solid8-cro-product"] && !Shopify.designMode) return;
  try {
    
function initializeSolid8Products(root=document){root.querySelectorAll('[data-s8-product]').forEach(section=>{if(section.dataset.initialized)return;section.dataset.initialized='true';const form=section.querySelector('form'),price=section.querySelector('[data-s8-price]'),terms=section.querySelector('[data-s8-terms]'),qty=form.querySelector('[name="quantity"]');let subscription=false;
const updatePrice=()=>{const plan=section.querySelector('[data-s8-options]:not([hidden]) [data-s8-plan]:checked');if(!plan)return;subscription=!!plan.value;price.textContent=plan.dataset.price;const selectedSupply=form.querySelector('[data-s8-variant]:checked');const stickySelection=section.querySelector('[data-s8-sticky-selection]');if(stickySelection&&selectedSupply){const label=selectedSupply.closest('label').querySelector('[data-s8-supply-title]');stickySelection.textContent=(subscription?label.dataset.subTitle:label.dataset.onceTitle)+' · '+plan.dataset.price;}terms.hidden=!subscription;section.querySelectorAll('.s8-card-price').forEach(card=>{card.textContent=subscription?card.dataset.subPrice:card.dataset.oncePrice});section.querySelectorAll('button[name="add"]').forEach(b=>{if(!b.disabled&&!b.closest('.s8-sticky'))b.textContent='Add to cart · '+plan.dataset.price})};
const changeVariant=()=>{const variant=form.querySelector('[data-s8-variant]:checked');section.querySelectorAll('[data-s8-options]').forEach(panel=>{const active=panel.dataset.s8Options===variant.value;panel.hidden=!active;panel.disabled=!active;if(active){const options=[...panel.querySelectorAll('[data-s8-plan]')];const choice=options.find(o=>subscription?!!o.value:!o.value)||options[0];if(choice)choice.checked=true}});qty.min=variant.dataset.min;qty.step=variant.dataset.step;variant.dataset.max?qty.max=variant.dataset.max:qty.removeAttribute('max');qty.value=variant.dataset.min;const url=new URL(location.href);url.searchParams.set('variant',variant.value);const activePlan=section.querySelector('[data-s8-options]:not([hidden]) [data-s8-plan]:checked');if(activePlan?.value)url.searchParams.set('selling_plan',activePlan.value);else url.searchParams.delete('selling_plan');history.replaceState(null,'',url);updatePrice()};form.querySelectorAll('[data-s8-variant]').forEach(r=>r.addEventListener('change',changeVariant));form.querySelectorAll('[data-s8-plan]').forEach(r=>r.addEventListener('change',()=>{const url=new URL(location.href);if(r.value)url.searchParams.set('selling_plan',r.value);else url.searchParams.delete('selling_plan');history.replaceState(null,'',url);updatePrice()}));const requestedPlan=new URLSearchParams(location.search).get('selling_plan');if(requestedPlan){const match=[...section.querySelectorAll('[data-s8-options]:not([hidden]) [data-s8-plan]')].find(plan=>plan.value===requestedPlan);if(match)match.checked=true;}updatePrice();
const sticky=section.querySelector('.s8-sticky'),mainAdd=form.querySelector('button[name="add"]');let dismissed=false;const syncChat=()=>{const host=document.getElementById('zipchat-shadow-host');if(!host||!host.shadowRoot)return;if(!host.shadowRoot.querySelector('[data-s8-chat-spacing]')){const style=document.createElement('style');style.dataset.s8ChatSpacing='';style.textContent='#widget-chat-container{bottom:var(--s8-chat-bottom,20px)!important}';host.shadowRoot.appendChild(style)}const offset=window.innerWidth<=749&&!sticky.hidden?(window.innerHeight-sticky.getBoundingClientRect().top+12)+'px':'';if(host.style.getPropertyValue('--s8-chat-bottom')!==offset){if(offset)host.style.setProperty('--s8-chat-bottom',offset);else host.style.removeProperty('--s8-chat-bottom')}};const stickyAdd=sticky.querySelector('button[name="add"]');const updateSticky=()=>{const rect=mainAdd.getBoundingClientRect();const beforePurchase=rect.top>=window.innerHeight;sticky.hidden=dismissed||(!beforePurchase&&rect.bottom>0);stickyAdd.type=beforePurchase?'button':'submit';stickyAdd.textContent=beforePurchase?'Choose supply':'Add to cart';syncChat()};stickyAdd.addEventListener('click',event=>{if(stickyAdd.type==='button'){event.preventDefault();form.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});form.querySelector('[data-s8-variant]:checked')?.focus({preventScroll:true});window.solid8PublishCroEvent?.('product_choose_supply_click',{product_handle:section.dataset.productHandle});}});const stickyObserver=new IntersectionObserver(updateSticky,{threshold:0});stickyObserver.observe(mainAdd);let stickyFrame=0;const queueSticky=()=>{if(stickyFrame)return;stickyFrame=requestAnimationFrame(()=>{stickyFrame=0;updateSticky()})};window.addEventListener('scroll',queueSticky,{passive:true});window.addEventListener('resize',queueSticky);section.querySelector('.s8-sticky-dismiss').addEventListener('click',()=>{dismissed=true;sticky.hidden=true;syncChat()});new ResizeObserver(syncChat).observe(sticky);let chatAttempts=0;const waitForChat=()=>{syncChat();const host=document.getElementById('zipchat-shadow-host');if(!host?.shadowRoot&&chatAttempts++<40)setTimeout(waitForChat,500)};waitForChat();updateSticky();
const image=section.querySelector('.s8-main-image'),zoom=section.querySelector('.s8-zoom'),dialog=section.querySelector('dialog');section.querySelectorAll('[data-s8-image]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();image.closest('picture')?.querySelector('source')?.remove();if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches&&image.animate)image.addEventListener('load',()=>image.animate([{opacity:.35},{opacity:1}],{duration:320,easing:'ease-out'}),{once:true});image.srcset=link.dataset.displaySrcset;image.src=link.dataset.displaySrc;image.alt=link.querySelector('img').alt;zoom.href=link.href;section.querySelectorAll('[data-s8-image]').forEach(x=>x.removeAttribute('aria-current'));link.setAttribute('aria-current','true')}));zoom.addEventListener('click',event=>{event.preventDefault();dialog.querySelector('img').src=zoom.href;dialog.querySelector('img').alt=image.alt;dialog.showModal()});section.querySelector('[data-s8-close]').addEventListener('click',()=>dialog.close());});}
initializeSolid8Products();document.addEventListener('shopify:section:load',event=>initializeSolid8Products(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solid8-cro-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.s8-review-carousel').forEach(section=>{const move=direction=>{const list=section.querySelector('.jdgm-review-list');if(list)list.scrollBy({left:direction*(list.querySelector('.jm-review-item').getBoundingClientRect().width+20),behavior:'smooth'})};section.querySelector('[data-s8-review-prev]').addEventListener('click',()=>move(-1));section.querySelector('[data-s8-review-next]').addEventListener('click',()=>move(1));});

  } catch(e) { console.error(e); }
})();
})();
